import { createContextManager } from './context-manager';

type Factory<T> = () => T;

class ResolutionError extends Error {}

const withResolutionContext = createContextManager<readonly Factory<unknown>[]>(
  [],
);

export class DependencyContainer {
  private registry = new WeakMap<Factory<unknown>, unknown>();

  resolve<T>(factory: Factory<T>): T {
    return withResolutionContext((dependencyChain, setDependencyChain) => {
      const cached = this.registry.get(factory);
      if (cached != null) {
        return cached as T;
      }
      if (dependencyChain.includes(factory)) {
        console.error('Circular dependency detected when resolving:', factory);
        throw new ResolutionError('Circular dependency');
      }
      setDependencyChain([...dependencyChain, factory]);
      const value = factory();
      this.registry.set(factory, value);
      return value;
    });
  }

  register<T>(factory: Factory<T>, value: T) {
    this.registry.set(factory, value);
    return this;
  }
}

/**
 * The global service locator
 */
export const injector = new DependencyContainer();
